module.exports = __webpack_public_path__ + "static/lena-cc7f984ce5241987d94d0cd0fc82d377.jpg";